{
  "kpiGroups": [
    {
      "id": "leadTime",
      "label": "Lead Time",
      "defaultCategoryWeight": 25,
      "kpis": [
        { "id": "lt_creationLeadTime", "label": "Creation lead time", "defaultWeight": 5 },
        { "id": "lt_completionLeadTime", "label": "Completion lead time", "defaultWeight": 5 },
        { "id": "lt_approvalLeadTime", "label": "Approval Lead time", "defaultWeight": 0 },
        { "id": "lt_resubmissionDelay", "label": "Resubmission Delay", "defaultWeight": 3 },
        { "id": "lt_outliers", "label": "Outliers", "defaultWeight": 5 },
        { "id": "lt_woCreationAfterGateOut", "label": "WO creation after GATE OUT", "defaultWeight": 2 },
        { "id": "lt_oosBanding", "label": "OOS (with Banding)", "defaultWeight": 3 },
        { "id": "lt_longstanding", "label": "Longstanding (With Banding)", "defaultWeight": 2 }
      ]
    },
    {
      "id": "processCompliance",
      "label": "Process Compliance",
      "defaultCategoryWeight": 35,
      "kpis": [
        { "id": "pc_rejectionRatio", "label": "Rejection ratio (with category)", "defaultWeight": 5 },
        { "id": "pc_missRelease", "label": "Miss release of containers (FG, Sale/redelivery) &", "defaultWeight": 0 },
        { "id": "pc_containerGrade", "label": "Container Grade Policy Adherence", "defaultWeight": 6 },
        { "id": "pc_pictureUpload", "label": "Picture upload compliance", "defaultWeight": 0 },
        { "id": "pc_pictureQuality", "label": "Picture Quality (Acceptance ratio)", "defaultWeight": 0 },
        { "id": "pc_ptiCompliance", "label": "PTI Compliance (Green, PTI, SPT)", "defaultWeight": 5 },
        { "id": "pc_liveReport", "label": "Live repair compliance", "defaultWeight": 0 },
        { "id": "pc_rcdReplacement", "label": "RCD Replacement/Fix", "defaultWeight": 2 },
        { "id": "pc_softwareUpload", "label": "Software upload failure", "defaultWeight": 3 },
        { "id": "pc_warrantyPerformance", "label": "Warranty performance", "defaultWeight": 5 },
        { "id": "pc_ptiQuality", "label": "PTI Quality", "defaultWeight": 3 },
        { "id": "pc_artPerformance", "label": "ART Performance", "defaultWeight": 3 },
        { "id": "pc_repairEvacuation", "label": "Repair and evacuation", "defaultWeight": 3 }
      ]
    },
    {
      "id": "eeir",
      "label": "Electronic EIR",
      "defaultCategoryWeight": 15,
      "kpis": [
        { "id": "eeir_gateOut", "label": "Gate out EIR creation Utilization", "defaultWeight": 5 },
        { "id": "eeir_gateIn", "label": "Gate in EIR creation Utilization", "defaultWeight": 5 },
        { "id": "eeir_quality", "label": "EIR Quality (Picture upload compliance & Quality)", "defaultWeight": 5 }
      ]
    },
    {
      "id": "auditResult",
      "label": "Audit Result",
      "defaultCategoryWeight": 25,
      "kpis": [
        { "id": "ar_containerRepairAudit", "label": "Container/Repair quality Audit", "defaultWeight": 15 },
        { "id": "ar_depotSafetyAudit", "label": "Depot Safety Audit", "defaultWeight": 10 }
      ]
    }
  ],
  "settingsProfiles": [
    { "id": "default", "tags": ["Default"], "shopCount": 989, "vendorCodes": ["V001"] },
    { "id": "p1", "tags": ["No Eeir"], "shopCount": 12, "vendorCodes": ["V002"] },
    { "id": "p2", "tags": ["Reef Only", "Dry Only"], "shopCount": 34, "vendorCodes": ["V003"] },
    { "id": "p3", "tags": ["LAM Shops"], "shopCount": 7, "vendorCodes": ["V004"] },
    { "id": "p4", "tags": ["WCA Shops", "Redelivery Shops"], "shopCount": 58, "vendorCodes": ["V005"] },
    { "id": "p5", "tags": ["No Eeir", "Reef Only"], "shopCount": 21, "vendorCodes": ["V006"] },
    { "id": "p6", "tags": ["Dry Only", "LAM Shops", "WCA Shops"], "shopCount": 5, "vendorCodes": ["V007"] },
    { "id": "p7", "tags": ["Redelivery Shops"], "shopCount": 9, "vendorCodes": ["V008"] },
    { "id": "p8", "tags": ["No Eeir", "Redelivery Shops"], "shopCount": 3, "vendorCodes": ["V009"] }
  ],
  "scoreOptions": [1, 2, 3, 4, 5],
  "unitOptions": ["None", "%", "hours", "days"]
}
